export default __webpack_public_path__ + "static/media/discord.741e707e.png";